import { createContext } from 'react';
import type { RoleContextValue } from '@/types/role';

export const RoleContext = createContext<RoleContextValue | undefined>(undefined);